export {
  mapCreateModelToFhirLocation,
  mapFhirLocationToModel,
  mapUpdateModelToFhirLocation,
} from './mapping';

export type {
  CreateLocation,
  GetAcuityResponse,
  GetLocationResponse,
  Location,
  LocationBase,
  LocationGetAllResponse,
  LocationSearchParams,
  LocationStatus,
  UpdateLocation,
} from './schema';
export {
  BaseLocationSchema,
  CreateLocationSchema,
  GetAcuityResponseSchema,
  GetLocationResponseSchema,
  LocationGetAllResponseSchema,
  LocationSchema,
  LocationSearchSchema,
  LocationStatusSchema,
  LocationTypeSchema,
  SupportedLocationStatus,
  UpdateLocationSchema,
} from './schema';
